import React, {useState, useEffect, useContext} from "react";
import { Col, Row, Alert } from "antd";
import { isMobile } from "../common/viewBreakpoints";
import SignInWidget from "./SignInWidget";
import { useMediaQuery } from "react-responsive";
import CustomHeaderView from "../common/CustomHeaderView";
import GuestPageContainer from '../common/GuestPageContainer';
import queryString from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import * as groupActions from "../../redux/actions/groupActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import * as ccAnalytics from "../../util/analytics/ccAnalytics";
import UIContext from "../../util/UIContext";

const SignInPage = ({ isBusiness, group, actions, ...props }) => {

  const uiContext = useContext(UIContext);

  const [isFacebookEmailError, setFacebookEmailError] = useState(false);
  const [groupReference, setGroupReference] = useState();
  const [mainHeaderText, setMainHeaderText] = useState("Sign in or create an account to see your climate impact grow");
  const [mainHeaderSubText, setMainHeaderSubText] = useState();
  let history = useHistory();
  let location = useLocation();
  const urlParams = new URLSearchParams(location.search)
  const emailDomains = uiContext?.emailDomains;

  const titleStyle = emailDomains?.length > 0 && !isBusiness && 'font-p-bold';

  const isClimateFriendlyTeamFlow = urlParams.get("from")?.match('/my-cc/climate-friendly-team.*');

  const isMobileDevice = isMobile(useMediaQuery);
  const headerRightText = isBusiness ? 
  (isClimateFriendlyTeamFlow ? "Sign up to Climate Friendly Team": uiContext.content.signIn.business.formHeaderText)
   : "Sign in or create an account";

  const industryId = urlParams.get("industryId");
  const countryCode = urlParams.get("country");

  const googleAnalyticsPage = 'signin-page';

  useEffect(() => {
    if (isBusiness) {
      setMainHeaderText("Access the portal to start your climate action journey")
    }
    setGroupReference(getGroupRefFromFromUri());

    let parsed = history && history.location && queryString.parse(history.location.hash);
    const errorFB = parsed && parsed.error_description ? parsed.error_description : "";
    if (errorFB.includes("email"))
      setFacebookEmailError(true);
    const timer = setTimeout(() => {
      setFacebookEmailError(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, [])

  useEffect(() => {
    if (groupReference && props.cognitoGuest && props.cognitoGuest.isSignedIn) {
      actions.getGroupByReference(groupReference);
    }
  }, [groupReference, props.cognitoGuest])

  useEffect(() => {
    if (group) {
      setMainHeaderSubText(`You'll be joining ${group.name}`);
    }
  }, [group])

  useEffect(() => {
    ccAnalytics.pageview(googleAnalyticsPage);
  }, [])

  const getGroupRefFromFromUri = () => {
    const fromURI = new URLSearchParams(location.search).get("from");

    if (fromURI) {
      const groupUriMatches = fromURI.match('.*/join-movement/([^?^/]*).*');
      if (groupUriMatches && groupUriMatches.length === 2) {
        return groupUriMatches[1];
      }
    }
  };

  const businessTitle = isClimateFriendlyTeamFlow ? 'Enhanced climate action across your team' : uiContext.content.signIn.business.headerText;

  return (
    <>
      {isMobileDevice ? (
        <>
          <Row>

          {isBusiness ?
                <div className="img-cover h-320px w-100 position-relative color-white" style={{ backgroundImage: `var(--dark-top-overlay), ${uiContext.content.signIn.business.backgroundImage}` }}>
                  <div className="px-3" style={{paddingTop: '6vh'}}>
                    <h3>{businessTitle}</h3>
                  </div>
                  <div className="left-abs px-3 mt-10px h-80px">
                    {uiContext.content?.signIn?.business?.secondLogoUrl && <img style={{maxWidth: '350px', maxHeight: '23px', marginTop: '15px', marginBottom: '15px', display: 'block'}}
                          src={uiContext.content?.signIn?.business?.secondLogoUrl}/>}
                    <img className='sign-in-business-logo' src={uiContext.content.mobileLogo.light} />
                  </div>
                </div>
                :
                <CustomHeaderView
                customImageSrc={uiContext.content.signIn.individual.backgroundImage}
                customLogo={uiContext?.content.mobileLogo.light}
                isMobileDevice={true}
                text={mainHeaderText}
                subText={mainHeaderSubText}
              />
              }

        
          </Row>
          <Row className="content-main">
            {isFacebookEmailError && <Alert
              message="Oops, we need your email address, please sign up using your email address below instead."
              type="info"
              showIcon
            />}
            <div style={DIV_STYLE} className={titleStyle}>{headerRightText}</div>
            <SignInWidget industryId={industryId} isBusiness={isBusiness} isClimateFriendlyTeamFlow={isClimateFriendlyTeamFlow} googleAnalyticsPrefixText={googleAnalyticsPage} />
          </Row>
          <div style={COPYRIGHT_STYLE}>
            <span>
              {/*{`© Copyright ${new Date().getFullYear()}, CarbonClick`}*/}
            </span>
          </div>
        </>
      ) : (
        <>
          <Row>
            <Col span={12}>

              {isBusiness ?
                <div className="img-cover h-100vh w-100 position-relative color-white" style={{ backgroundImage: `var(--dark-top-overlay), var(--dark-bottom-overlay), ${uiContext.content.signIn.business.backgroundImage}` }}>
                  <div className="px-3" style={{paddingTop: '6vh'}}>
                    <h2>{businessTitle}</h2>
                  </div>
                  <div
                      className={`position-absolute bottom-abs left-abs p-3 ${uiContext.content?.signIn?.business?.secondLogoUrl && 'd-flex'}`}
                      style={uiContext.content?.signIn?.business?.secondLogoUrl && {alignItems: "center"}}
                  >
                    <img style={{maxWidth: '350px', maxHeight: '300px', minWidth: '220px'}} src={uiContext.content.logo.light}/>
                    {uiContext.content?.signIn?.business?.logoSeparatorUrl &&
                        <img style={{maxWidth: '25px', maxHeight: '25px', marginLeft: '10px'}} src={uiContext.content?.signIn?.business?.logoSeparatorUrl} />
                    }
                    {uiContext.content?.signIn?.business?.secondLogoUrl &&
                        <img style={{maxWidth: '350px', maxHeight: '23px', marginLeft: '10px'}} src={uiContext.content?.signIn?.business?.secondLogoUrl} />
                    }
                  </div>
                </div>
                :
                <CustomHeaderView
                  customImageSrc={uiContext.content.signIn.individual.backgroundImage}
                  customLogo={uiContext?.content.logo.light}
                  isSideView={true}
                  isMobileDevice={false}
                  text={mainHeaderText}
                  subText={mainHeaderSubText}
                />
              }


            </Col>
            <GuestPageContainer>
              {isFacebookEmailError && <Alert
                message="Oops, we need your email address, please sign up using your email address below instead."
                type="info"
                showIcon
              />}
              <span style={{padding:'12px', textAlign:'left'}}>
                <div style={DIV_STYLE} className={titleStyle}>{headerRightText}</div>
                <SignInWidget countryCode={countryCode} industryId={industryId} isBusiness={isBusiness} isClimateFriendlyTeamFlow={isClimateFriendlyTeamFlow} googleAnalyticsPrefixText={googleAnalyticsPage} />
              </span>
            </GuestPageContainer>
          </Row>
        </>
      )}
    </>
  );
};

const COPYRIGHT_STYLE = { textAlign: "center", paddingBottom: 10 };

const DIV_STYLE = {
  fontWeight: 400,
  fontSize: "28px",
  paddingBottom: 20
};


function mapStateToProps(state) {
  return {
    loading: !state.group,
    group: state.group,
    cognitoGuest: state.cognitoGuest
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      getGroupByReference: bindActionCreators(groupActions.getGroupByReference, dispatch)
    }
  };
}

SignInPage.propTypes = {
  group: PropTypes.object,
  actions: PropTypes.object,
  cognitoGuest: PropTypes.object,
  'cognitoGuest.isSignedIn': PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(SignInPage));